import { useLocalization } from "@fluent/react";
import { modules } from "byzantine";
import { useNotificationContext } from "cerulean/src/NotificationContext/NotificationContext";

const useAoiobLink = () => {
  const { l10n } = useLocalization();
  const { sendNegativeNotification } = useNotificationContext();
  const { fetchAoiobLink } = modules.aoiob.useFetchAoiobLink();

  const open = () =>
    fetchAoiobLink({
      onSuccess: ({ link }: { link: string }) => {
        const success = window.open(link, "_blank");
        // important not to check falsey
        // null is returned if the new browsing context fails
        if (success === null) {
          sendNegativeNotification(
            l10n.getString(
              "services-item-open-an-account-popup-failed-error",
              null,
              "We cannot open the application. Please adjust your browser's pop-up settings."
            )
          );
        }
      },
    });

  return open;
};

export default useAoiobLink;
